module.exports.responsiveSlotPlacements = [
  {
    id: '/4987/staging',
    bidders: [
      {
        name: 'criteo',
        adSizes: [
          [ '1x1', {networkId: 8804} ],
          [ '300x250', {networkId: 8804} ],
          [ '300x600', {networkId: 8804} ],
          [ '970x250', {networkId: 8804} ]
        ]
      },
      {
        name: 'appnexus',
        adSizes: [
          [ '1x1', {placementId: '14487486'} ],
          [ '300x250', {placementId: '14487486'} ],
          [ '300x600', {placementId: '14487486'} ],
          [ '970x250', {placementId: '14487486'} ]
        ]
      },
      {
        name: 'ozone',
        adSizes: [
          [ '320x50', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '300x250', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '300x600', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '970x250', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ]
        ]
      }
    ]
  },
  {
    id: '/4987/thecourier',
    bidders: [
      {
        name: 'criteo',
        adSizes: [
          [ '1x1', {networkId: 8804} ],
          [ '300x250', {networkId: 8804} ],
          [ '300x600', {networkId: 8804} ],
          [ '970x250', {networkId: 8804} ]
        ]
      },
      // http://prebid.org/dev-docs/bidders/indexExchange.html
      {
        name: 'ix',
        adSizes: [
          [ '300x250', {siteId: '400846', size: [ 300, 250 ]} ],
          [ '300x600', {siteId: '400892', size: [ 300, 600 ]} ],
          [ '970x250', {siteId: '400894', size: [ 970, 250 ]} ]
        ]
      },
      {
        name: 'appnexus',
        adSizes: [
          [ '1x1', {placementId: '14487486'} ],
          [ '300x250', {placementId: '14487486'} ],
          [ '300x600', {placementId: '14487486'} ],
          [ '970x250', {placementId: '14487486'} ]
        ]
      },
      {
        name: 'ozone',
        adSizes: [
          [ '320x50', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '300x250', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '300x600', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ],
          [ '970x250', {publisherId: 'OZONETSG0001', siteId: '4204204228', placementId: '1420430756'} ]
        ]
      },
	    {
		    name: 'adyoulike',
		    adSizes: [
			    [ '300x250', {placement: 'ea59e21f46be477cba12edcbce954454'} ],
			    [ '300x600', {placement: '06b6190c5ec55dc80e706de8889c9e84'} ],
			    [ '970x250', {placement: '06b6190c5ec55dc80e706de8889c9e84'} ]
		    ]
	    },
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643099'} ],
          [ '300x600', {placementId: '22643099'} ],
          [ '970x250', {placementId: '22643099'} ]
        ]
      },
    ]
  },
  {
    id: '/4987/pressandjournal',
    bidders: [
      {
        name: 'criteo',
        adSizes: [
          [ '1x1', {networkId: 8804} ],
          [ '300x250', {networkId: 8804} ],
          [ '300x600', {networkId: 8804} ],
          [ '970x250', {networkId: 8804} ]
        ]
      },
      // http://prebid.org/dev-docs/bidders/indexExchange.html
      {
        name: 'ix',
        adSizes: [
          [ '300x250', {siteId: '513294', size: [ 300, 250 ]} ],
          [ '300x600', {siteId: '513307', size: [ 300, 600 ]} ],
          [ '970x250', {siteId: '513322', size: [ 970, 250 ]} ]
        ]
      },
      {
        name: 'appnexus',
        adSizes: [
          [ '1x1', {placementId: '14489452'} ],
          [ '300x250', {placementId: '14489452'} ],
          [ '300x600', {placementId: '14489452'} ],
          [ '970x250', {placementId: '14489452'} ]
        ]
      },
      {
        name: 'ozone',
        adSizes: [
          [ '320x50', {publisherId: 'OZONETSG0001', siteId: '4204204231', placementId: '1420430759'} ],
          [ '300x250', {publisherId: 'OZONETSG0001', siteId: '4204204231', placementId: '1420430759'} ],
          [ '300x600', {publisherId: 'OZONETSG0001', siteId: '4204204231', placementId: '1420430759'} ],
          [ '970x250', {publisherId: 'OZONETSG0001', siteId: '4204204231', placementId: '1420430759'} ]
        ]
      },
	    {
		    name: 'adyoulike',
		    adSizes: [
			    [ '300x250', {placement: 'e2811fc3655dfb91ea0376a4023d34fb'} ],
			    [ '300x600', {placement: '3ee5b05b001c7cea9e3dc2ea8f81641a'} ],
			    [ '970x250', {placement: '3ee5b05b001c7cea9e3dc2ea8f81641a'} ]
		    ]
	    },
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643098'} ],
          [ '300x600', {placementId: '22643098'} ],
          [ '970x250', {placementId: '22643098'} ]
        ]
      },
    ]
  },
  {
    id: '/4987/sundaypost',
    bidders: [
      {
        name: 'criteo',
        adSizes: [
          [ '1x1', {networkId: 8804} ],
          [ '300x250', {networkId: 8804} ],
          [ '300x600', {networkId: 8804} ],
          [ '970x250', {networkId: 8804} ]
        ]
      },
      // http://prebid.org/dev-docs/bidders/indexExchange.html
      {
        name: 'ix',
        adSizes: [
          [ '300x250', {siteId: '400847', size: [ 300, 250 ]} ],
          [ '300x600', {siteId: '400896', size: [ 300, 600 ]} ],
          [ '970x250', {siteId: '400899', size: [ 970, 250 ]} ]
        ]
      },
      {
        name: 'appnexus',
        adSizes: [
          [ '1x1', {placementId: '14490483'} ],
          [ '300x250', {placementId: '14490483'} ],
          [ '300x600', {placementId: '14490483'} ],
          [ '970x250', {placementId: '14490483'} ]
        ]
      },
      {
        name: 'ozone',
        adSizes: [
          [ '300x250', {publisherId: 'OZONETSG0001', siteId: '4204204233', placementId: '1420430761'} ],
          [ '300x600', {publisherId: 'OZONETSG0001', siteId: '4204204233', placementId: '1420430761'} ],
          [ '970x250', {publisherId: 'OZONETSG0001', siteId: '4204204233', placementId: '1420430761'} ]
        ]
      },
	    {
		    name: 'adyoulike',
		    adSizes: [
			    [ '300x250', {placement: '8faa3629c2833ebef875934dabedffe1'} ],
			    [ '300x600', {placement: 'a968de0c806bb6420e3c301cdcb769e7'} ],
			    [ '970x250', {placement: 'a968de0c806bb6420e3c301cdcb769e7'} ]
		    ]
	    },
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643100'} ],
          [ '300x600', {placementId: '22643100'} ],
          [ '970x250', {placementId: '22643100'} ]
        ]
      },
    ]
  },
  {
    id: '/4987/energyvoice',
    bidders: [
      {
        name: 'criteo',
        adSizes: [
          [ '1x1', {networkId: 8804} ],
          [ '300x250', {networkId: 8804} ],
          [ '300x600', {networkId: 8804} ],
          [ '970x250', {networkId: 8804} ]
        ]
      },
      // http://prebid.org/dev-docs/bidders/indexExchange.html
      {
        name: 'ix',
        adSizes: [
          [ '300x250', {siteId: '400849', size: [ 300, 250 ]} ],
          [ '300x600', {siteId: '400902', size: [ 300, 600 ]} ],
          [ '970x250', {siteId: '400904', size: [ 970, 250 ]} ]
        ]
      },
      {
        name: 'appnexus',
        adSizes: [
          [ '1x1', {placementId: '14487792'} ],
          [ '300x250', {placementId: '14487792'} ],
          [ '300x600', {placementId: '14487792'} ],
          [ '970x250', {placementId: '14487792'} ]
        ]
      },
      {
        name: 'ozone',
        adSizes: [
          [ '300x250', {publisherId: 'OZONETSG0001', siteId: '4204204232', placementId: '1420430760'} ],
          [ '300x600', {publisherId: 'OZONETSG0001', siteId: '4204204232', placementId: '1420430760'} ],
          [ '970x250', {publisherId: 'OZONETSG0001', siteId: '4204204232', placementId: '1420430760'} ]
        ]
      },
	    {
		    name: 'adyoulike',
		    adSizes: [
			    [ '300x250', {placement: '8359faa5e2c20e2036e3951880674734'} ],
			    [ '300x600', {placement: 'ab2168c988344e1185b44263dbed0b75'} ],
			    [ '970x250', {placement: 'ab2168c988344e1185b44263dbed0b75'} ]
		    ]
	    },
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643104'} ],
          [ '300x600', {placementId: '22643104'} ],
          [ '970x250', {placementId: '22643104'} ]
        ]
      },
    ]
  },
	{
		id: '/4987/myweekly',
		bidders: [
			{
				name: 'adyoulike',
				adSizes: [
					[ '300x250', {placement: '35cd46b58fb06c1907073af9af318036'} ],
					[ '300x600', {placement: 'd97bc6fa1e38aa49355e88353898431d'} ],
					[ '970x250', {placement: 'd97bc6fa1e38aa49355e88353898431d'} ]
				]
			},
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643101'} ],
          [ '300x600', {placementId: '22643101'} ],
          [ '970x250', {placementId: '22643101'} ]
        ]
      },
		]
	},
	{
		id: '/4987/scotsmagnew',
		bidders: [
			{
				name: 'adyoulike',
				adSizes: [
					[ '300x250', {placement: '2f9aec00964958fa3568f268a77ec501'} ],
					[ '300x600', {placement: 'f467471a8708badb0b8818c6307e8c1f'} ],
					[ '970x250', {placement: 'f467471a8708badb0b8818c6307e8c1f'} ]
				]
			},
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643102'} ],
          [ '300x600', {placementId: '22643102'} ],
          [ '970x250', {placementId: '22643102'} ]
        ]
      },
		]
	},
	{
		id: '/4987/platinum-mag',
		bidders: [
			{
				name: 'adyoulike',
				adSizes: [
					[ '300x250', {placement: '18671c27bb229a7306ef577d9494a141'} ],
					[ '300x600', {placement: 'e94e3aedc7b3c022922304620ef39b7f'} ],
					[ '970x250', {placement: 'e94e3aedc7b3c022922304620ef39b7f'} ]
				]
			},
		]
	},
	{
		id: '/4987/society',
		bidders: [
			{
				name: 'adyoulike',
				adSizes: [
					[ '300x250', {placement: '634d540f5da020f226d047c3995ecdb0'} ],
					[ '300x600', {placement: '8e004fcc604573dea5f6f4e98f901ce9'} ],
					[ '970x250', {placement: '8e004fcc604573dea5f6f4e98f901ce9'} ]
				]
			},
		]
	},
	{
		id: '/4987/besteverxmas',
		bidders: [
			{
				name: 'adyoulike',
				adSizes: [
					[ '300x250', {placement: '65897acf0bff6a7891ff08ae6f3a4ed8'} ],
					[ '300x600', {placement: 'dca6c2ab59b975a75bb320f0e1beaf32'} ],
					[ '970x250', {placement: 'dca6c2ab59b975a75bb320f0e1beaf32'} ]
				]
			},
		]
	},
  {
    id: '/4987/peoples_friend',
    bidders: [
      {
        name: 'improvedigital',
        adSizes: [
          [ '300x250', {placementId: '22643103'} ],
          [ '300x600', {placementId: '22643103'} ],
          [ '970x250', {placementId: '22643103'} ]
        ]
      },
    ]
  }
];
